import { Map, Set } from 'immutable';
import { LocationInfo, Authtoken } from '../../types';
import { TasksBackendClient } from '../../backends/tasks';

type ConfigState = Map<string, any>;

export const userInfoExists = (state: ConfigState): boolean => {
    return state.get('userInfoExists');
};

export const customerId = (state: ConfigState): string => {
    return state.get('customerId');
};

export const userId = (state: ConfigState): string => {
    return state.get('userId');
};

export const browserLocation = (state: ConfigState): LocationInfo => {
    return state.get('browserLocation');
};

export const tasksBackendClient = (state: ConfigState): TasksBackendClient => {
    return state.get('tasksBackendClient');
};

export const authtoken = (state: ConfigState): Authtoken | undefined => {
    return state.getIn(['authtoken', 'current']) as Authtoken | undefined;
};
